const UUID=/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const PRIVATE_PREFIX='private_';

export function privateRecipeCustomCodeFromProductId(productId){
  const id=String(productId??'').trim().toLowerCase();
  if(!UUID.test(id))throw new TypeError('Private Recipe custom product id must be a UUID');
  return PRIVATE_PREFIX+id.replaceAll('-','');
}

export function privateRecipeProductIdFromCustomCode(code){
  const value=String(code??'').trim().toLowerCase();
  if(!value.startsWith(PRIVATE_PREFIX))return null;
  const hex=value.slice(PRIVATE_PREFIX.length);
  if(!/^[0-9a-f]{32}$/.test(hex))return null;
  const uuid=[
    hex.slice(0,8),
    hex.slice(8,12),
    hex.slice(12,16),
    hex.slice(16,20),
    hex.slice(20)
  ].join('-');
  return UUID.test(uuid)?uuid:null;
}
